// @flow
import { error } from './common';
import * as types from '../types/users';
import type {
  USER_TYPE,
  USERS_FETCH_STARTED_TYPE,
  USERS_FETCH_SUCCEED_TYPE,
  USER_FETCH_STARTED_TYPE,
  USER_FETCH_SUCCEED_TYPE,
  USER_SELECTED_TYPE,
  ADD_USER_STARTED_TYPE,
  ADD_USER_SUCCEED_TYPE,
  ADD_USER_CANCELED_TYPE,
  ADD_USER_ERROR_CLEARED_TYPE,
  USER_FILTERS_CHANGED_TYPE,
  CREATE_USERS_STEP_UPDATED_TYPE,
  UPLOADING_USERS_ADDED_TYPE,
  UPLOAD_USERS_STARTED_TYPE,
  UPLOAD_USERS_SUCCEED_TYPE,
  UPLOADING_USERS_CLEARED_TYPE,
  START_FETCH_USER_CODE_TYPE,
  REMOVE_USER_STARTED_TYPE,
  REMOVE_USER_SUCCEED_TYPE,
  UPDATE_USER_SUCCEDED_TYPE,
  UPDATE_USER_STARTED_TYPE,
} from '../types/users';
import type { ID_TYPE } from '../types/common';

export const startFetchingUsers = (page: number): USERS_FETCH_STARTED_TYPE => ({
  type: types.USERS_FETCH_STARTED,
  payload: {
    page,
  },
});

export const fetchUsersSucceed = (
  entities: {[number]: USER_TYPE},
  order: Array<number>,
  page?: number,
  next?: number,
): USERS_FETCH_SUCCEED_TYPE => ({
  type: types.USERS_FETCH_SUCCEED,
  payload: {
    entities,
    order,
    page,
    next,
  },
});

export const fetchUsersFailed = error(types.USERS_FETCH_FAILED);

export const selectUser = (id: number): USER_SELECTED_TYPE => ({
  type: types.USER_SELECTED,
  payload: id,
});

export const fetchUserStarted = (id: number): USER_FETCH_STARTED_TYPE => ({
  type: types.USER_FETCH_STARTED,
  payload: id,
});

export const fetchUserSucceed = (
  id: string,
  result_type: string,
  first_name: string,
  last_name: string,
  phone: string,
  code: string,
  email: string,
  license_type: string,
  address?: string,
  parents?: Array<number>,
  token?: string,
): USER_FETCH_SUCCEED_TYPE => ({
  type: types.USER_FETCH_SUCCEED,
  payload: {
    id,
    result_type,
    first_name,
    last_name,
    phone,
    code,
    email,
    license_type,
    address,
    parents,
    token,
  },
});

export const addUserStart = (
  profile_picture: any,
  result_type: string,
  first_name: string,
  last_name: string,
  phone: string,
  code: string,
  email: string,
  license_type: string,
  address: string,
  complex_address: any,
  parents: Array<number>,
  stops_scheduling_going: Object,
  stops_scheduling_returning: Object,
  isContact: Boolean,
): ADD_USER_STARTED_TYPE => ({
  type: types.ADD_USER_STARTED,
  payload: {
    profile_picture,
    result_type,
    first_name,
    last_name,
    phone,
    code,
    email,
    license_type,
    address,
    complex_address,
    parents,
    stops_scheduling_going,
    stops_scheduling_returning,
    isContact,
  },
});

export const addUserSuccess = (user: USER_TYPE): ADD_USER_SUCCEED_TYPE => ({
  type: types.ADD_USER_SUCCEED,
  payload: user,
});

export const addUserFailed = error(types.ADD_USER_FAILED);

export const addUserCancel = (): ADD_USER_CANCELED_TYPE => ({
  type: types.ADD_USER_CANCELED,
});

export const clearAddUserError = (): ADD_USER_ERROR_CLEARED_TYPE => ({
  type: types.ADD_USER_ERROR_CLEARED,
});

export const fetchUserFailed = error(types.USER_FETCH_FAILED);

export const changeUserFilters = (key: string, filter: string): USER_FILTERS_CHANGED_TYPE => ({
  type: types.USER_FILTERS_CHANGED,
  payload: {
    key,
    filter,
  },
});

export const removeUserStart = (
  orderId: ID_TYPE,
  id: number,
  result_type: string,
): REMOVE_USER_STARTED_TYPE => ({
  type: types.REMOVE_USER_STARTED,
  payload: {
    orderId,
    id,
    result_type,
  },
});

export const removeUserSuccess = (id: number): REMOVE_USER_SUCCEED_TYPE => ({
  type: types.REMOVE_USER_SUCCEED,
  payload: id,
});

export const removeUserFailed = error(types.USER_REMOVED_FAILED);

export const updateUserStart = (changed_user: Object): UPDATE_USER_STARTED_TYPE => ({
  type: types.UPDATE_USER_STARTED,
  payload: changed_user,
});

export const updateUserSucceed = (user: USER_TYPE): UPDATE_USER_SUCCEDED_TYPE => ({
  type: types.UPDATE_USER_SUCCEDED,
  payload: user,
});

export const updateUserFailed = error(types.UPDATE_USER_FAILED);

export const updateCreateUsersStep = (step: number): CREATE_USERS_STEP_UPDATED_TYPE => ({
  type: types.CREATE_USERS_STEP_UPDATED,
  payload: step,
});

export const addUploadingUsers = (
  entities: {[number]: USER_TYPE},
  order: Array<number>,
): UPLOADING_USERS_ADDED_TYPE => ({
  type: types.UPLOADING_USERS_ADDED,
  payload: {
    entities,
    order,
  },
});

export const uploadUsersStart = (
  users: Array<USER_TYPE>,
): UPLOAD_USERS_STARTED_TYPE => ({
  type: types.UPLOAD_USERS_STARTED,
  payload: {
    users,
  },
});

export const uploadUsersSuccess = (): UPLOAD_USERS_SUCCEED_TYPE => ({
  type: types.UPLOAD_USERS_SUCCEED,
});

export const clearUploadingUsers = (): UPLOADING_USERS_CLEARED_TYPE => ({
  type: types.UPLOADING_USERS_CLEARED,
  payload: {
    byId: {},
    order: [],
  },
});


export const startFetchUserCode = (
  id: number,
  stateUserId: string,
): START_FETCH_USER_CODE_TYPE => ({
  type: types.START_FETCH_USER_CODE,
  payload: {
    id,
    stateUserId,
  },
});



// WEBPACK FOOTER //
// ./src/scripts/actions/users.js